<template>
    <card-grid-item
        :tab-widget="tabWidget"
        :card-class="['card-grid']"
        :min-w="3"
        :min-h="minHeight"
        :resized="handleResized"
        @tab-widget-settings-click="handleTabWidgetSettingsClick"
    >
        <template v-slot:card-title>
            {{ title }}
        </template>
        <template v-slot:card-body>
            <card-grid
                ref="grid"
                :key="cardGridKey"
                :is-search="false"
                :columnDefs="columnDefs"
                :fetch-callback="fetchCallback"
                :pagination="true"
                :pagination-page-size="limit"
                :cache-block-size="limit"
            ></card-grid>
        </template>
        <template v-slot:tab-widget-settings-modal>
            <tab-widget-settings-modal-form
                :modal-id="tabWidgetSettingsModalID"
                :update="updateTabWidgetSettings"
                :initial-values="tabWidgetSettingsInitialValues"
                @success-update="handleSuccessTabWidgetSettingsUpdate"
            ></tab-widget-settings-modal-form>
        </template>
    </card-grid-item>
</template>

<script>
    import API from '../../../../api';
    import CardGrid from '../../../generic/card-grid/card-grid.vue';
    import CardGridItem from '../common/card-grid-item.vue';
    import { DASHBOARD_SUBSCRIBER_GRID_ENDPOINT } from '../../../../endpoints';
    import { escapeHTML } from '../../../../utils/strings';
    import { getWidgetGridRowsNumber } from '../helpers';
    import { mapGetters } from 'vuex';
    import TabWidgetSettingsModalForm from '../common/tab-widget-settings-modal-form.vue';
    import cardGridItemBaseMixin from '../common/card-grid-item-base-mixin';

    export default {
        name: 'LapsedSubscribersTableCardGridItem',
        mixins: [cardGridItemBaseMixin],

        components: {
            CardGrid,
            CardGridItem,
            TabWidgetSettingsModalForm,
        },
        computed: {
            ...mapGetters('header', ['userPermissions']),
            fetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    this.offset = offset;
                    this.limit = limit;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;
                    return API.get(DASHBOARD_SUBSCRIBER_GRID_ENDPOINT(), {
                        params: {
                            offset,
                            limit,
                            sort,
                            desc,
                            search,
                            lapsed: true,
                        }
                    });
                };
            },
        },
        data() {
            return {
                columnDefs: [
                    {
                        field: 'id',
                        hide: true,
                    },
                    {
                        field: 'recent_subscription.last_status_change',
                        headerName: 'Date',
                        type: 'dateColumn',
                        sort: 'desc',
                        minWidth: 150,
                    },
                    {
                        field: 'client_fields.full_name',
                        headerName: 'Name',
                        cellRenderer: ({ data }) =>
                            data &&
                            data.client_fields &&
                            escapeHTML(data.client_fields.short_name || data.client_fields.full_name),
                        minWidth: 190,
                    },
                    {
                        field: 'client_fields.address.short_name',
                        headerName: 'Address',
                        sortable: false,
                        minWidth: 280,
                    },
                    {
                        field: 'recent_subscription.package_name',
                        headerName: 'Package',
                        sortable: false,
                        minWidth: 250,
                    },
                    {
                        headerName: 'Modules',
                        autoHeight: true,
                        minWidth: 320,
                        sortable: false,
                        cellRenderer: ({ data }) =>
                            data &&
                            data.recent_subscription &&
                            data.recent_subscription.modules.map(item => escapeHTML(item.module_name)).join('<br />')
                    },
                    {
                        field: 'recent_subscription.total_amount',
                        headerName: 'Price',
                        type: 'amountColumn',
                        sortable: false,
                    },
                ],
                offset: 0,
                limit: getWidgetGridRowsNumber({ tabWidget: this.tabWidget }),
                sort: 'id',
                desc: false,
                search: '',
            }
        },
        methods: {
            handleResized() {
                this.limit = getWidgetGridRowsNumber({ tabWidget: this.tabWidget });
                this.cardGridKey += 1;
            },
        }
    };
</script>
